import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getDateAdapterLocale, mapBackendLanguageToApp } from '@src/shared/lib';
import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

type MuiDateProviderProps = PropsWithChildren;

export default function MuiDateProvider({ children }: MuiDateProviderProps) {
  const { i18n } = useTranslation();
  const appLanguage = mapBackendLanguageToApp(i18n.resolvedLanguage);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={getDateAdapterLocale(appLanguage)}
    >
      {children}
    </LocalizationProvider>
  );
}
